import { useTabState } from 'reakit/Tab';
import Image from 'next/image';
import cc from 'classnames';

import { queries, mutations } from '@/utils/demo-for-engineering';
import styles from '@/styles/pages/home.module.css';
import HomeSectionHero from './HomeSectionHero';
import Tab from './Tab';
import TabList from './TabList';
import TabPanel from './TabPanel';
import Playground from './Playground';

export default function EngineeringTabs() {
  const tabEng = useTabState({ selectedId: `queries-mutations` });

  return (
    <>
      <div
        className={cc(
          styles.gridEng,
          styles.gridTabs,
          `my-8 pt-1 md:mt-0 md:pt-0`,
        )}
      >
        <TabList
          tab={tabEng}
          aria-label="Graphcms For Engineering teams"
          withBottomBorder
          className="col-start-1 h-full items-center justify-center text-light-haiti lg:col-start-2"
        >
          <Tab
            tab={tabEng}
            id="queries-mutations"
            activeColor="text-cornflower"
          >
            Queries & Mutations
          </Tab>
          <Tab
            tab={tabEng}
            id="structured-content"
            className="mx-8"
            activeColor="text-cornflower"
          >
            Structured Content
          </Tab>
          <Tab
            tab={tabEng}
            id="content-federation"
            activeColor="text-cornflower"
          >
            External Data Sourcing
          </Tab>
        </TabList>
      </div>

      <div>
        <TabPanel
          tab={tabEng}
          id="queries-mutations"
          className={cc(styles.gridEng, `focus:outline-none lg:min-h-[462px]`)}
        >
          <div>
            <HomeSectionHero
              badge="GraphCMS For Engineering teams"
              title="All Your Content One API Call Away"
              description="Meet the industry’s most robust GraphQL APIs to boost developer productivity. All your content is hosted in the data center of your choice, and served from the world’s fastest Edge CDN."
              colors={{
                badge: `text-cornflower`,
                text: `text-whisper`,
                title: `text-white`,
              }}
              cta={{
                href: `/for-engineering`,
                label: `Explore GraphCMS for Engineering Teams`,
              }}
            />
          </div>

          <Playground queries={queries} mutations={mutations} />
        </TabPanel>
        <TabPanel
          tab={tabEng}
          id="structured-content"
          className={cc(styles.gridEng, `focus:outline-none lg:min-h-[462px]`)}
        >
          <div>
            <HomeSectionHero
              badge="GraphCMS For Engineering teams"
              title="Become A Content Architect"
              description="Easy but expressive content modeling allows you to structure your content within minutes using our intuitive schema builder. Environments help you evolve your content model safely."
              colors={{
                badge: `text-cornflower`,
                text: `text-whisper`,
                title: `text-white`,
              }}
              cta={{
                href: `/for-engineering`,
                label: `Explore GraphCMS for Engineering Teams`,
              }}
            />
          </div>

          <Image
            src="/images/home/structured-content.svg"
            alt="GraphCMS schema with three models, Actor, Show, and Episode, alongside their field types"
            width={575}
            height={380}
          />
        </TabPanel>
        <TabPanel
          tab={tabEng}
          id="content-federation"
          className={cc(styles.gridEng, `focus:outline-none lg:min-h-[462px]`)}
        >
          <div>
            <HomeSectionHero
              badge="GraphCMS For Engineering teams"
              title="Meet Content Federation"
              description="Build your ultimate content pipeline. GraphCMS allows API extensions and remote joins to fetch content and data from any external source."
              colors={{
                badge: `text-cornflower`,
                text: `text-whisper`,
                title: `text-white`,
              }}
              cta={{
                href: `/for-engineering`,
                label: `Explore GraphCMS for Engineering Teams`,
              }}
            />
          </div>

          <Image
            src="/images/home/content-federation.svg"
            alt="GraphQL Query fetching movies with a title from GraphCMS, rating from IMDb, a poster from Bynder, and prices from Shopify"
            width={518}
            height={291}
          />
        </TabPanel>
      </div>
    </>
  );
}
